import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { log } from 'util';

@Component({
  selector: 'subsection-row',
  template: `
  <!--todo this component is also the same just check the ngfor as facilities and services-->
  
  
  <div *ngIf="sectionRowOpen" class="row bg-w">
      <!--Desktop-->
  
      <!-- Subsection  -->
      
      <div class="hidden-xs hidden-sm">
          <div class="col-md-4">
              <p class="fz-18  m-0 ml-5 p-5">{{rowData.label}}</p>
          </div>
          <div class="col-md-8">
              <div class="row">
                  <div *ngFor="let cellValue of rowData.row | mobile:isMobile:columnHeader; let i = index">
                      <div *ngIf="i === 0" [ngClass]="{'col-md-offset-1': rowData?.row.length === 5,
                                    'col-md-offset-3': rowData?.row.length === 4,
                                    'col-md-offset-5': rowData?.row.length === 3}" class="col-md-2  ta-c">
                          <data-cell [cellValues]="cellValue.value"></data-cell>
                      </div>
                      <div *ngIf="i !== 0" class="col-md-2  ta-c">
                          <data-cell [cellValues]="cellValue.value"></data-cell>
                      </div>
                  </div>
              </div>
          </div>
  
          <!-- Sub-subsection  -->
  
          <div class="col-md-12">
              <div *ngFor="let rowData of metropolitanRowsArray" class="row mb-5">
                  <span class="col-md-4 pl-50">{{rowData.label}}</span>
                  <div class="col-md-8">
                      <div class="row">
                          <div *ngFor="let cellValue of rowData.row  | mobile:isMobile:columnHeader; let i = index">
                              <div *ngIf="i === 0" [ngClass]="{'col-md-offset-1': rowData?.row.length === 5,
                                        'col-md-offset-3': rowData?.row.length === 4,
                                        'col-md-offset-5': rowData?.row.length === 3}" class="col-md-2  ta-c">
                                  <data-cell [cellValues]="cellValue.value"></data-cell>
                              </div>
                              <div *ngIf="i !== 0" class="col-md-2  ta-c">
                                  <data-cell [cellValues]="cellValue.value"></data-cell>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- Mobile/Tablet -->
  
      <!-- Subsection -->
  
      <div class="visible-xs-block visible-sm-block">
          <div class="col-xs-8 col-sm-4  fw-700">
              {{rowData.label}}
          </div>
          <div *ngFor="let cellValue of rowData.row | mobile:isMobile:columnHeader; let i = index" class="  col-xs-4 col-sm-8">
              <div *ngIf="i === 0" class="ta-c fw-700">
                  <data-cell [cellValues]="cellValue.value"></data-cell>
              </div>
              <div *ngIf="i !== 0" class="ta-c fw-700">
                  <data-cell [cellValues]="cellValue.value"></data-cell>
              </div>
          </div>
  
          <!-- Sub-subsection  -->
  
      <div *ngFor="let rowData of metropolitanRowsArray" class="">
          <span class="col-xs-8 col-sm-4  ">{{rowData.label}}</span>
          <div *ngFor="let cellValue of rowData.row  | mobile:isMobile:columnHeader; let i = index" class=" col-xs-4 col-sm-8">
              <div *ngIf="i === 0" class="ta-c">
                  <data-cell [cellValues]="cellValue.value"></data-cell>
              </div>
              <div *ngIf="i !== 0" class="ta-c">
                  <data-cell [cellValues]="cellValue.value"></data-cell>
              </div>
          </div>
      </div>
  </div>

  `
})
export class SubsectionRowComponent implements OnInit {
  @Input() rowData;
  @Input() sectionRowOpen;
  @Input() isMobile;
  @Input() columnHeader;

  currentTableSectionState;
  metropolitanRowsArray;

  constructor(private store: Store<any>) {
    store.select('currentUser').subscribe(currentUser => {
      this.currentTableSectionState = currentUser;
      this.setLetsOpen(currentUser);
    });
  }

  ngOnInit() {
    this.getMetropolitanRows();
  }

  setLetsOpen(currentUser) {
    this.sectionRowOpen = currentUser.allSectionsOpen;
  }

  getMetropolitanRows() {
    if (this.rowData.label === 'Metropolitan' && this.rowData.subsection) {
      this.metropolitanRowsArray = this.rowData.subsection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/components-utl-per-fin/subsection-row/subsection-row.component.ts